import { useContext, createContext } from "react";
import { IContext } from "./types";

const initialState = {
  loading: false
};
const ProductContext = createContext<IContext>(initialState);

const useProduct = () => useContext(ProductContext);

export { ProductContext, useProduct };
